import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Trash2 } from "lucide-react";

const Deletepopup = ({ open, onClose, onConfirm, itemName, title }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      PaperProps={{
        sx: { zIndex: 2000, borderRadius: 2, p: 1 },
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 20,
      }}
    >
      <DialogTitle id="delete-dialog-title">
        <Box display="flex" alignItems="center" gap={1.5}>
          <Trash2 color="#d32f2f" size={22} />
          {title || "Delete Test Case"}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant="body1">
            Are you sure you want to <strong>{itemName || "this test case"}</strong>?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Deletepopup;
